import React from 'react';
import style from './style.module.scss';

const ClientNameContainer = ({ clientName = '' }) => {
  return (
    <div className={style.clientNameContainer}>
      <p>{clientName}</p>
    </div>
  );
};

export default ClientNameContainer;
